// @ts-strict-ignore
import React from 'react'
import SocialSharing from '../trustyle-social-sharing'
import { canonicalHref } from '../helpers/meta-tags'
import { contentId, pageTitle } from '../../utils/contentful'
import { useDataSelector, useEntity, useMeta } from '../helpers/selectors'

const SocialSharingCompound = ({ urlModule }) => {
  const address = canonicalHref(urlModule)
  const linkedPageId = contentId(urlModule.link)
  const linkedPage = useEntity(linkedPageId)
  const titleContent = pageTitle(linkedPage)
  const twitterAccount = useMeta('twitterAccount')
  const twitterMsg = twitterAccount ? `${address} via ${twitterAccount}` : ''

  return (
    <SocialSharing
      shareUrl={address}
      twitterMessage={twitterMsg}
      mailSubject={titleContent}
      brand={urlModule.brand}
    />
  )
}

const SocialSharingConnected = (props) => {
  const data = useDataSelector()
  const connectedProps = {
    urlModule: { ...data.url, ...data.rootEntity.fields },
    includes: data.includes,
  }
  return <SocialSharingCompound {...props} {...connectedProps} />
}

export default SocialSharingConnected
